import React from 'react'
import { createComponent } from '@ycos/fela'

const List = ({ children, ordered }) => {
  const Component = createComponent(
    'List',
    () => ({
      padding: 0,
      direction: 'ltr'
    }),
    ordered ? 'ol' : 'ul'
  )

  return <Component>{children}</Component>
}

export default List
